import { prospectsList, prospectByID, prospectsSync, prospectInvite, prospectBulkInvite, prospectStatus } from '@/services/agency/studioProspects.service'

export default {
	namespaced: true,
	state: {
		prospectsList: { data: [], meta: { pagination: { total: 0 } } },
		prospect: {},
		prospectsListStatus: 'init',
		prospectsSyncStatus: 'init',
		prospectsActionStatus: 'init',
	},
	getters: {
		getProspectsList:        state => state.prospectsList,
		getProspect:             state => state.prospect,
		getProspectsListStatus:  state => state.prospectsListStatus,
		getProspectsSyncStatus:  state => state.prospectsSyncStatus,
		getProspectsActionStatus: state => state.prospectsActionStatus,
	},
	mutations: {
		PROSPECTS_LIST(state, value)          { state.prospectsList = value },
		SET_PROSPECT(state, value)            { state.prospect = value },
		PROSPECTS_LIST_STATUS(state, value)   { state.prospectsListStatus = value },
		PROSPECTS_SYNC_STATUS(state, value)   { state.prospectsSyncStatus = value },
		PROSPECTS_ACTION_STATUS(state, value) { state.prospectsActionStatus = value },
	},
	actions: {
		async fetchProspectsList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('PROSPECTS_LIST_STATUS', 'pending')
			commit('PROSPECTS_LIST', { data: [], meta: { pagination: { total: 0 } } })
			try {
				const { data } = await prospectsList(params)
				commit('PROSPECTS_LIST_STATUS', 'init')
				commit('PROSPECTS_LIST', data)
				return data
			} catch (error) {
				commit('PROSPECTS_LIST_STATUS', 'init')
				throw error
			}
		},
		async fetchProspectByID({ commit }, id) {
			commit('PROSPECTS_LIST_STATUS', 'pending')
			try {
				const { data } = await prospectByID(id)
				commit('PROSPECTS_LIST_STATUS', 'init')
				commit('SET_PROSPECT', data.data)
				return data
			} catch (error) {
				commit('PROSPECTS_LIST_STATUS', 'init')
				throw error
			}
		},
		async syncProspects({ commit }, params) {
			commit('PROSPECTS_SYNC_STATUS', 'pending')
			try {
				const { data } = await prospectsSync(params)
				commit('PROSPECTS_SYNC_STATUS', 'init')
				return data
			} catch (error) {
				commit('PROSPECTS_SYNC_STATUS', 'error')
				throw error
			}
		},
		async sendInvite({ commit }, { id, params }) {
			commit('PROSPECTS_ACTION_STATUS', 'pending')
			try {
				const { data } = await prospectInvite(id, params)
				commit('PROSPECTS_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('PROSPECTS_ACTION_STATUS', 'error')
				throw error
			}
		},
		async bulkInvite({ commit }, params) {
			commit('PROSPECTS_ACTION_STATUS', 'pending')
			try {
				const { data } = await prospectBulkInvite(params)
				commit('PROSPECTS_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('PROSPECTS_ACTION_STATUS', 'error')
				throw error
			}
		},
		async updateStatus({ commit }, { id, params }) {
			commit('PROSPECTS_ACTION_STATUS', 'pending')
			try {
				const { data } = await prospectStatus(id, params)
				commit('PROSPECTS_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('PROSPECTS_ACTION_STATUS', 'error')
				throw error
			}
		},
	},
}
